import { useCallback, useEffect } from "react"
import { useNavigate, useLocation, Outlet } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { getCurrentUser, fetchAuthSession } from 'aws-amplify/auth'
import { Hub } from 'aws-amplify/utils'
import { StoreDispatch, RootState } from '../../store/configure-store'
import { setLoggedInUser } from '../../store/user'

interface ProtectedRoutesProps {
  children?: React.ReactNode;
}

export const ProtectedRoutes: React.FC<ProtectedRoutesProps> = (props) => {
  const navigate = useNavigate()
  const location = useLocation()
  const loggedInUser = useSelector((stateModule: RootState) => stateModule.users.user)!
  const dispatch = useDispatch<StoreDispatch>()

  const getLoggedInUser = useCallback(async () => {
    try {
      const currentUser = await getCurrentUser()

      // Password login: email is in signInDetails.loginId
      let email = currentUser.signInDetails?.loginId

      // Federated (Google) login: email comes from ID token attributes
      if (!email) {
        const session = await fetchAuthSession()
        const idToken = session.tokens?.idToken
        if (idToken) {
          email = idToken.payload.email as string
        }
      }

      if (email) return dispatch(setLoggedInUser(email))
      throw new Error("No email found for user")
    } catch {
      navigate("/login")
    }
  }, [dispatch, navigate])

  useEffect(() => {
  if (!loggedInUser) getLoggedInUser()
  }, [location, loggedInUser, getLoggedInUser]);

  // Listen for OAuth redirect completion (Google sign-in flow)
  useEffect(() => {
    const unsubscribe = Hub.listen('auth', ({ payload }) => {
      if (payload.event === 'signInWithRedirect') {
        getLoggedInUser()
      }
    })
    return unsubscribe
  }, [getLoggedInUser])

  if (!loggedInUser) return <div></div>

  return <section className="protected-content">
    <Outlet />
  </section>
};
